// Интервалы опросов бэкенда в мс.

// Период обновления карт, шаблонов и операций, пока шаблоны ещё не загружены или не вернули validTime.
export const CARD_DATA_REFRESH_INTERVAL_MS = 30_000

// Проверка готовности карты после оплаты выпуска.
export const CARD_ISSUE_POLL_INTERVAL_MS = 5_000

// Как часто во время выпуска карты дополнительно обновляются операции.
export const CARD_ISSUE_TRANSACTIONS_REFRESH_MS = 30_000

// Проверка оплаты пополнения карты.
export const CARD_TOPUP_POLL_INTERVAL_MS = 2_000
